export type DryingTechnology = "heat_pump" | "condenser" | "vented";

/** FIX-289: never replace a scan decision with EPREL or clear a known value. */
export function resolveScannedDryingTechnology(
  scanned: DryingTechnology | null | undefined,
  eprel: DryingTechnology | null | undefined,
): DryingTechnology | null {
  if (scanned && eprel && scanned !== eprel) {
    console.warn("FIX-289 drying technology conflict", { typeShield: scanned, eprel });
  }
  return scanned ?? eprel ?? null;
}

const norm = (v: string | null | undefined) =>
  (v || "").toLowerCase().replace(/[^a-z]/g, "");

/** Resolves dryer vs washer dryer from appliances.category / appliance_class. */
export function dryingTechnologyKind(
  category: string | null | undefined,
  applianceClass?: string | null,
): "dryer" | "washer_dryer" | null {
  const c = norm(category);
  if (c.includes("washerdryer") || c.includes("washerdrier") || norm(applianceClass) === "washerdryer")
    return "washer_dryer";
  if (c === "dryer" || c === "tumbledryer" || norm(applianceClass) === "tumbledryer") return "dryer";
  return null;
}

/** Options offered per category. Vented is never offered for washer dryers. */
export function dryingTechnologyOptions(
  category: string | null | undefined,
  applianceClass?: string | null,
): DryingTechnology[] {
  const kind = dryingTechnologyKind(category, applianceClass);
  if (kind === "dryer") return ["heat_pump", "condenser", "vented"];
  if (kind === "washer_dryer") return ["heat_pump", "condenser"];
  return [];
}
